import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMask from '@devindex/vue-mask'

import Notifications from '@kyvg/vue3-notification'
import { faPix } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
library.add(faPix)

// createApp(App).component('fa', FontAwesomeIcon).use(store).use(router).use(Notifications).use(VueMask).mount('#app')

async function bootstrap () {
  // 1. carrega definições antes de montar o app
  await store.dispatch('loadAppDefinitions')

  // 2. define se é full app com base na URL
  const dnsCliMini = store.getters.getAppDefinitions?.dnsCliMini || null

  let isFullApp = true
  if (!dnsCliMini) {
    console.error('DNS CLI Mini not defined in app definitions')
    isFullApp = true
  } else {
    isFullApp = !window.location.href.includes(dnsCliMini)
  }
  await store.dispatch('setFullApp', isFullApp)

  createApp(App)
    .component('fa', FontAwesomeIcon)
    .use(store)
    .use(router)
    .use(Notifications)
    .use(VueMask)
    .mount('#app')
}

bootstrap()
